const DiscountInfluencerAnalisysActionConfigurationDietGroupsTier = (
	json: IDiscountInfluencerAnalisysActionConfigurationDietGroupsTier,
): IDiscountInfluencerAnalisysActionConfigurationDietGroupsTierModel => {
	const { max_amount, percent } = json

	return {
		maxAmount: max_amount,
		percent,
	}
}

const DiscountInfluencerAnalisysActionConfigurationDietGroupsTiers = (
	json: IDiscountInfluencerAnalisysActionConfigurationDietGroupsTiers,
): IDiscountInfluencerAnalisysActionConfigurationDietGroupsTiersModel => {
	const { tiers } = json

	return {
		tiers: tiers.map(DiscountInfluencerAnalisysActionConfigurationDietGroupsTier),
	}
}

const DiscountInfluencerAnalisysActionConfigurationDietGroups = (
	json: IDiscountInfluencerAnalisysActionConfigurationDietGroups,
): IDiscountInfluencerAnalisysActionConfigurationDietGroupsModel => {
	const { menu_selection, kids_menu, daily_selection } = json

	return {
		menuSelection: menu_selection
			? DiscountInfluencerAnalisysActionConfigurationDietGroupsTiers(menu_selection)
			: null,
		kidsMenu: kids_menu ? DiscountInfluencerAnalisysActionConfigurationDietGroupsTiers(kids_menu) : null,
		dailySelection: daily_selection
			? DiscountInfluencerAnalisysActionConfigurationDietGroupsTiers(daily_selection)
			: null,
	}
}

const DiscountInfluencerAnalisysActionConfiguration = (
	json: IDiscountInfluencerAnalisysActionConfiguration,
): IDiscountInfluencerAnalisysActionConfigurationModel => {
	const { diet_groups, amount, percent } = json

	return {
		amount,
		percent,
		dietGroups: diet_groups ? DiscountInfluencerAnalisysActionConfigurationDietGroups(diet_groups) : undefined,
	}
}

const DiscountInfluencerAnalisysAction = (
	json: IDiscountInfluencerAnalisysAction,
): IDiscountInfluencerAnalisysActionModel => {
	const { type, configuration } = json

	return {
		type,
		configuration: configuration ? DiscountInfluencerAnalisysActionConfiguration(configuration) : null,
	}
}

const DiscountInfluencerAnalisysPromotion = (
	json: IDiscountInfluencerAnalisysPromotion,
): IDiscountInfluencerAnalisysPromotionModel => {
	const { id, commission, influencer_name, actions } = json

	return {
		id,
		commission,
		influencerName: influencer_name,
		actions: actions ? actions.map(DiscountInfluencerAnalisysAction) : [],
	}
}

const DiscountInfluencerAnalisysStatistics = (
	json: IDiscountInfluencerAnalisysStatistics,
): IDiscountInfluencerAnalisysStatisticsModel => {
	const { total_sales, total_commission, usage_count, commission_percentage } = json

	return {
		totalSales: total_sales,
		totalCommission: total_commission,
		usageCount: usage_count,
		commissionPercentage: commission_percentage,
	}
}

const DiscountInfluencerAnalisysMonthlyHistory = (
	json: IDiscountInfluencerAnalisysMonthlyHistory,
): IDiscountInfluencerAnalisysMonthlyHistoryModel => {
	const { year, month, sales_amount, commission_amount, usage_count, commission_percentage } = json

	return {
		year,
		month,
		salesAmount: sales_amount,
		commissionAmount: commission_amount,
		usageCount: usage_count,
		commissionPercentage: commission_percentage,
	}
}

export const DiscountInfluencerAnalisys = (json: IDiscountInfluencerAnalisys): IDiscountInfluencerAnalisysModel => {
	const { id, code, usage_count, promotion, statistics, monthly_history } = json

	return {
		id,
		code,
		usageCount: usage_count,
		promotion: DiscountInfluencerAnalisysPromotion(promotion),
		statistics: statistics ? DiscountInfluencerAnalisysStatistics(statistics) : null,
		monthlyHistory: monthly_history,
	}
}

/**
 * Models details group
 */
export const DiscountInfluencerAnalisysDetails = (
	json: IDiscountInfluencerAnalisysDetails,
): IDiscountInfluencerAnalisysDetailsModel => {
	const { id, code, usage_count, promotion, statistics, monthly_history } = json

	return {
		id,
		code,
		usageCount: usage_count,
		promotion: DiscountInfluencerAnalisysPromotion(promotion),
		statistics: statistics ? DiscountInfluencerAnalisysStatistics(statistics) : null,
		monthlyHistory: monthly_history ? monthly_history.map(DiscountInfluencerAnalisysMonthlyHistory) : [],
	}
}
